import { render } from "./TheMbPriceAndCaution.vue?vue&type=template&id=6c2964ca"
import script from "./TheMbPriceAndCaution.vue?vue&type=script&lang=js"
export * from "./TheMbPriceAndCaution.vue?vue&type=script&lang=js"
script.render = render

export default script